


































































































import {Component, Prop, Vue} from 'vue-property-decorator';
import Cognito from "@/authorization/cognito";
import Translate from "@/consoleapi/api/translate";

@Component
export default class SignUp extends Vue {
    @Prop() private msg!: string;

    email: string;
    password: string;
    passwordConfirm: string;

    termsOfService = false;
    privacyPolicy = false;
    personalInformation = false;

    constructor() {
        super();
        this.email = '';
        this.password = '';
        this.passwordConfirm = '';
    }

    signUp() {
        if (!this.validation()) {
            return;
        }
        this.doSignUp(this.email, this.password);
    }

    doSignUp(email: string, password: string) {
        const cognito = new Cognito();
        cognito.signUp(email, password)
            .then(result => {
                //console.log(result);
                //this.sign_up = false;
                localStorage.email = email;
                this.$router.push('confirm');
            })
            .catch(err => {
                //console.log(err);
                cognito.getCognitoUser(email).getUserAttributes(function (err, attributes) {
                    if (err) {
                        //console.log(err);
                    } else {
                        //console.log(attributes);
                    }
                });

                if (err.code === 'UsernameExistsException') {
                    cognito.resendConfirmUrl(email);
                    alert('すでに登録済みです。仮登録が完了していない場合は、送付されたEメールのリンクから仮登録を完了してください。');
                    return;
                }
                this.translate(err.message || JSON.stringify(err));
            });
    }

    translate(message: string) {
        const translate = new Translate();
        translate.get(message)
            .then(response => {
                alert(response.data.text);
            })
            .catch(error => {
                //console.log(error.response);
                alert(message);
            })
    }

    /**
     *
     */
    validation() {
        if (this.email === '') {
            return false;
        }
        if (this.password === '') {
            return false;
        }
        if (this.password !== this.passwordConfirm) {
            alert('確認用パスワードが一致しません');
            return false;
        }

        if (!this.termsOfService) {
            alert('サービス利用規約に同意してください。');
            return false;
        }
        if (!this.privacyPolicy) {
            alert('個人情報保護方針に同意してください。');
            return false;
        }
        if (!this.personalInformation) {
            alert('個人情報の取り扱いについて同意してください。');
            return false;
        }
        return true;
    }

    // パスワード表示トグル
    private isChecked?: boolean = false;

    get inputType() {
        return this.isChecked ? "text" : "password"
    }

    get iconType() {
        return this.isChecked ? "eye" : "eye-slash";
    }

    toggle() {
        this.isChecked = !this.isChecked;
    }
}
